import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformResponseHandler } from 'utils/transformResponseHandler';

export const profileApi = createApi({
    reducerPath: 'profileApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_ROUTE}`,
        prepareHeaders: (headers, { getState }) => {
            const token = getState()?.posData?.token;
            if (token) {
                headers.set('Authorization', token);
            }
            return headers;
        },
    }),
    tagTypes: ['Profile'],
    endpoints: (builder) => ({
        updateProfile: builder.mutation({
            query: (body) => ({
                // url: '/pos/profile',
                url: '/pos/profile',
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Profile'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error),
        }),
        uploadResPhotos: builder.mutation({
            query: (formData) => ({
                url: '/pos/profile/photos/upload',
                method: 'POST',
                body: formData,
            }),
            invalidatesTags: ['Profile'], // Invalidate to refetch vendor data with new photos
            // transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error),
        }),
        deleteResPhoto: builder.mutation({
            query: (body) => ({
                url: '/pos/profile/photos/delete',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Profile'],
            // transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error),
        }),
    }),
});

export const {
    useUpdateProfileMutation,
    useUploadResPhotosMutation,
    useDeleteResPhotoMutation
} = profileApi;
